import logo from '../../../src/assets/images/logo-rpc.png';

const LogoIconRpc = () => {
  return <img src={logo} width="100" height="80" alt="logo-rpc" />;
};

export default LogoIconRpc;
